<template>
  <b-modal
    :title="title"
    v-model="localShow"
    :modal-class="'modal-zindex-top'"
    centered
    scrollable
    hide-footer
    @hidden="handleHidden"
  >
    <ValidationObserver ref="observerModalVacinas" class="row">
      <div class="col-lg-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="mb-2">
            <the-mask
              :mask="['##/##/####']"
              v-model="form.dataAplicacao"
              required
              class="form-control"
              placeholder="Data da aplicação"
            />
          </div>
          <div class="error">{{ errors[0] }}</div>
        </validation-provider>
      </div>
      <div class="col-lg-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="mb-2">
            <input
              name="lote"
              v-model="form.lote"
              class="form-control"
              placeholder="Lote"
              type="text"
              required
            />
          </div>
          <div class="error">{{ errors[0] }}</div>
        </validation-provider>
      </div>
      <div class="col-lg-12">
        <button
          type="submit"
          class="btn mt-2"
          :disabled="form.btn.disabled"
          @click="salvar()"
        >
          Salvar
          <b-spinner
            small
            label="Small Spinner"
            variant="white"
            v-if="form.btn.loading"
          />
        </button>
      </div>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'
import utils from '@/mixins/utils.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
    cidadao: {
      type: Object,
      default: null,
    },
  },
  mixins: [utils],
  components: {
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  data() {
    return {
      form: {
        dataAplicacao: null,
        lote: null,
        btn: {
          disabled: false,
          loading: false,
        },
      },
    }
  },
  computed: {
    // espelha o prop 'show' e emite update:show quando mudar
    localShow: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      },
    },
  },
  methods: {
    async salvar() {
      try {
        const isValid = await this.$refs.observerModalVacinas.validate()

        if (!isValid) return

        this.form.btn.loading = true

        const payload = {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: this.cidadao.nu_cpf ?? this.cidadao.nu_cns,
          nu_cns: this.cidadao.nu_cns,
          nu_cpf: this.cidadao.nu_cpf,
          cpf_profissional: this.cidadao.profissional,
          id_imunobiologico: this.item.id_mn,
          id_dose_imunobiologico: this.item.id_ds,
          lote: this.form.lote,
          dt_aplicacao: this.converterParaDataIso(this.form.dataAplicacao),
        }

        // Salvar efb vacina
        let response = await this.$api.post('/app/efb-vacina', payload)
        if (response.data.error === false) {
          this.$toast.success('Vacina salva com sucesso!', 'Sucesso:', {
            position: 'topRight',
          })

          this.$emit('saved', {
            id_mn: this.item.id_mn,
            id_ds: this.item.id_ds,
          })
        }

        this.localShow = false
      } finally {
        this.form.btn.loading = false
      }
    },

    handleHidden() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style></style>
